export default __webpack_public_path__ + "static/media/Meals4MeInsta.19a7b402.png";